import React from "react";

const Section1Introduction = () => (
  <>
    <h2>1. Introduction</h2>
    <p>
    Comparedly.com is a social media analytics tool designed to provide users with insights into their social media performance and audience engagement. These Terms and Conditions of Use ("Terms") govern your access to and use of the Comparedly.com service, including all related websites, applications, software, and services (collectively, the "Service"). This agreement constitutes a legally binding contract between you, the user, and Comparedly Ltd., a company registered in England and Wales. By registering for, accessing, or using Comparedly.com, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, you must not use the Service. If you are using the Service on behalf of an organization, you represent and warrant that you have the authority to bind that organization to these Terms, and all references to "you" or "your" in these Terms shall refer to such organization.
    </p>
  </>
);

export default Section1Introduction;
